<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Asparagus"><div class="titlepage"><div><div><h1 class="title"><a id="d0e311" xmlns:saxon="http://icl.com/saxon"></a>Asparagus
                        </h1></div></div></div><p><span class="emphasis"><em>Asparagus
                        officinalis</em></span></p><p class="underline">In the last century B.C.,
                the Roman Emperor Caesar Augustus, </p><p class="underline">intent on mustering his
                troops at a more rapid pace, </p><p class="underline"> coined the phrase <span class="emphasis"><em>velocius quam asparagi conquantur, </em></span>translating
                </p><p class="underline">to “faster than you can cook asparagus.” </p><p><span class="dropcap">A</span>sparagus, originally native to the eastern Mediterranean
                and Asia Minor, is a sufficiently ancient food plant to have been pictured, at least
                as a wild specimen, on an Egyptian frieze dating to 3000 B.C., and has been under
                human cultivation for at least 2,000 years. <span class="emphasis"><em>Asparagus</em></span> comes to us from the Greek <span class="emphasis"><em>asparagi,</em></span> meaning “sprout” or “shoot,” and Julius Caesar
                was known to have enjoyed them anointed with melted butter. His heir, Caesar
                Augustus, was so enamored of this flavorsome edible that he initiated an entire
                “Asparagus Fleet” for the sole purpose of shipping the best specimens back to Rome
                with optimal speed while at the same time employing the Empire’s fleetest athletes
                to transport fresh spears into the Alps, where they could be frozen for
                out-of-season enjoyment. Apicius, arguably the world’s first cookbook author,
                included a recipe for preparing asparagus in the <span class="emphasis"><em>De re
                        coquinaria</em></span> of the third century A.D.; then, oddly, asparagus
                seems to have gone underground during the Middle Ages, only to make a dramatic
                comeback on the culinary scene in the sixteenth century. The spears, poetically
                noted to be “the size of a swan’s feather,” gained such fashionable status in France
                and England that Louis XIV himself proclaimed them “the food of kings” and they were
                deemed fit for the tables of the nobility alone. In the eighteenth century,
                asparagus gained quite a fol</p><div class="mediaobject" title="Photo of female asparagus."><img alt="Photo of female asparagus." src="images/Asparagus2.jpg"/><div class="caption"><p>Female Asparagus in
                        seed</p></div></div><p>lowing as a purported aphrodisiac, the “love tips”
                    (“<span class="emphasis"><em>points d’amour”</em></span>) having been famously
                served as a delicacy to Madame de Pompadour at the court of Louis XV. </p><p>As it
                transpires, asparagus is an excellent source of vitamin B6, dietary fiber, calcium,
                and zinc, and a good source of protein, beta-carotene, vitamins C, E, and K, as well
                as folic acid, iron, phosphorus, potassium, copper, and manganese. All of these
                factors combine to make asparagus powerfully antioxidant as well as
                anti-inflammatory and an excellent diuretic in the promotion of kidney health.
                </p><p>Asparagus is available in both purple and green varieties, the purple types
                being the progeny of the Italian heirloom ‘Violetto d’ Albenga’. White asparagus are
                simply the result of blanching green spears as they grow by hilling up the earth
                around the crowns. Thanks mainly to plant breeders at New Jersey’s Rutgers
                University, today’s improved and all-male strains of asparagus, like ‘Jersey Giant’,
                ‘Jersey Supreme’, and ‘Jersey Knight’, are far easier to plant than the antique
                cultivars like the female ‘Martha Washington’ and produce almost twice as much in
                the bargain. </p><p>Therefore, in early spring, prepare a weed-free, well-fertilized
                bed large enough to accommodate two dozen male asparagus crowns spaced 12 to 18
                inches apart in two side-by-side trenches 6 to 12 inches deep. Situate each crown on
                a mound of compost enhanced with an organic fertilizer with some phosphorus content
                about 6 inches below the soil surface, allowing the roots to drape down around the
                mound. Cover the roots with garden soil right up to the crown, water well, and as
                shoots develop add more soil until the trench has been filled level with the soil
                surface. Keep your bed well mulched, well watered, and weed free, and don’t pick
                    <span class="emphasis"><em>any</em></span> of the spears the first year, as the
                crowns get their energy from the ferny growth that develops as the tips mature into
                fronds. By the third year, a modest planting of two dozen male crowns will start
                yielding up to 20 pounds of edible spears per year for a very impressive fifteen to
                twenty years! </p><p>In terms of culinary employment, shall we harken back to Julius
                Caesar and that melted butter idea with just a squeeze of lemon?</p><div class="mediaobject" title="Photo of ."><img alt="Photo of ." src="images/Asparagus1.jpg"/><div class="caption"><p>Asparagus</p></div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch06.vue?52a71489